import EfBanner from '@elem/ui/ef-banner';
import EfEmarsysEmail from '@elem/ui/ef-emarsys-email';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.Banner');

    const itemA = {
        label: t('label'),
        title: t('title'),
        desc: t('desc'),
        pc: 'https://websiteoss.ecoflow.com/upload/image/1723002234980/pc_kv.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1723002244272/m_kv.jpg',
        theme: 'black',
        hasEmail: true,
        emailChildren: (
            <div className="Banner-email">
                <EfEmarsysEmail
                    theme="black"
                    needTerms={true}
                    contactListId="126004015"
                    fields={[
                        {
                            id: '9120',
                            type: 'multiple',
                            value: [8],
                            overwrite: false,
                        },
                        {
                            id: '9157',
                            type: 'multiple',
                            value: [3],
                            overwrite: false,
                        },
                        {
                            id: '31',
                            type: 'single',
                            value: 1,
                            overwrite: true,
                        },
                        {
                            id: '4431',
                            type: 'single',
                            value: 1,
                            overwrite: true,
                        },
                    ]}
                />
            </div>
        ),
    };
    return (
        <div className={styles.TheComp}>
            <EfBanner {...itemA} />
        </div>
    );
}
